import React from "react"
import ReactDOMServer from "react-dom/server"
import { Avatar, Icon, message } from "antd"

import DoubtsService from "services/students/doubts.service"
import globalStore from "store/index"

import "./Index.css"

export default class Lightbox extends React.Component {
  state = {
    isOpen: false,
    slideIndex: 1,
  }

  componentDidMount() {
    document.addEventListener(
      "click",
      (e) => {
        if (this.hasClass(e.target, "lightbox-close")) {
          const lightbox = document.getElementById("lightbox-root")
          lightbox && lightbox.remove()
        }
      },
      false,
    )
  }

  hasClass = (elem, className) => {
    return elem.classList.contains(className)
  }

  openLightbox = (url) => {
    const html = ReactDOMServer.renderToString(this.renderLightbox({ url: url }))
    const lightbox = document.getElementById("lightbox-root")

    if (lightbox) {
      lightbox.innerHTML = html
      return
    }

    const lightboxDiv = document.createElement("div")

    lightboxDiv.id = "lightbox-root"
    lightboxDiv.innerHTML = html

    document.getElementsByTagName("body")[0].appendChild(lightboxDiv)
  }

  deleteItem = async ({ image, doubtId }) => {
    const pageState = globalStore.ui.students.doubts.deleteAttachment
    await DoubtsService.deleteAttachment({
      pageState,
      doubtId,
      attachmentId: image.attachment_id,
    })

    if (pageState.doubtErrors) {
      message.destroy()
      message.error("Failed to delete audio.")
      return
    }

    message.destroy()
    message.success("Audio deleted successfully.")

    globalStore.ui.students.doubts.show.doubt = pageState.doubt

    console.log("delete attachment:", pageState)
  }

  renderThumbnails = () => {
    const { images, deletable, doubtId } = this.props

    return (
      <div className="lightbox-thumbnails">
        {images.map((image, i) => (
          <div className="deletable-item" key={i}>
            <div key={i} className="lightbox-thumbnail" onClick={() => this.openLightbox(image.url)}>
              <Avatar style={{ backgroundColor: "#b9b9b9" }} shape="square" size={64} src={image.url} />
            </div>
            {deletable && (
              <div className="delete-icon" onClick={() => this.deleteItem({ image, doubtId })}>
                <Icon type="delete" />
              </div>
            )}
          </div>
        ))}
      </div>
    )
  }

  renderLightbox = ({ url, description, alt }) => {
    return (
      <div className="lightbox-modal">
        <div className="lightbox-close">&times;</div>
        <div className="lightbox">
          <div className="image-box">
            <img src={url} alt={alt || ""} />
          </div>
          <div className="image-description">{description || ""}</div>
        </div>
      </div>
    )
  }

  render() {
    const { images } = this.props

    if (images && images.length === 0) return null

    return <div className="lightbox-wrapper">{this.renderThumbnails()}</div>
  }
}
